export const environment = {
  production: true,
  searchUrl: "https://api.sds.basf.com:9446/api/search",
  advancedUserUrl: "https://api.sds.basf.com:9446/api/isAdvancedUser",
  shortlinkUrl: "https://api.sds.basf.com:9446/api/shortlink",
  qrlinkUrl: "https://api.sds.basf.com:9446/api/qr",
  salesOrgUrl: "https://api.sds.basf.com:9446/api/salesOrg",
  userFilterUrl: "https://api.sds.basf.com:9446/api/user-filter",
  currentUserUrl: "https://api.sds.basf.com:9446/api/user",
  viewUrl: "https://api.sds.basf.com:9446/api/view",
  downloadUrl: "https://api.sds.basf.com:9446/api/download",
  downloadZipUrl: "https://api.sds.basf.com:9446/api/download-zip",
  releaseNotesUrl: "https://api.sds.basf.com:9446/api/release-notes",
  feedbackUrl: "https://api.sds.basf.com:9446/api/feedback",
  errorMessagesUrl: "https://api.sds.basf.com:9446/api/error-messages",
  oidc: {
    authority: 'https://login.microsoftonline.com/ecaa386b-c8df-4ce0-ad01-740cbdb5ba55/v2.0',
    clientId: 'aa721e9f-a30e-4666-9105-cae29b009924',
    redirectUrl: 'https://sds.basf.com',
    postLogoutRedirectUri: 'https://sds.basf.com/oauth/callback',
    scopes: 'openid profile offline_access api://aa721e9f-a30e-4666-9105-cae29b009924/user_impersonation',
    authorizationEndpoint: 'https://login.microsoftonline.com/ecaa386b-c8df-4ce0-ad01-740cbdb5ba55/oauth2/v2.0/authorize',
    tokenEndpoint: 'https://login.microsoftonline.com/ecaa386b-c8df-4ce0-ad01-740cbdb5ba55/oauth2/v2.0/token'
  }
};
